import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import {LoadRegistrastionJournyData} from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function CloseResolvedTroubleTicketsService(token) {
    return axios.post(`${CURRENT_API_URL}/swhelpdesk/closeResolvedTroubleTickets`,'',{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("All resolved tickets closed successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while resolved tickets closed. please try again later.");
        return false;
    });
}

export default CloseResolvedTroubleTicketsService
;